import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { lifecycle, compose, withHandlers, withState } from 'recompose'

import { page } from 'utils/trackingUtils'
import { popUp } from "./helpers"

import InstallSegment from './component'

import * as ApiKeySelectors from 'modules/apiKey/selectors'
import * as OrgSelectors from 'modules/org/selectors'

import * as OrgActions from 'modules/org/actions'

const mapStateToProps = state => ({
  embedId: OrgSelectors.getEmbedId(state),
  apiKey: ApiKeySelectors.apiKey(state)
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    updateOrgProperties: OrgActions.updateOrgProperties,
  }, dispatch),
})

export default compose(
  withState('updating', 'setUpdating', false),
  withState('segmentEnabled', 'setSegmentEnabled', false),
  withState('errorNotification', 'setErrorNotification', false),
  withState('successNotification', 'setSuccessNotification', false),
  withState('showNextButton', 'setShowNextButton', false),
  connect(mapStateToProps,mapDispatchToProps),
  lifecycle({
    componentDidMount() {
      page('Onboarding Segment Install Setup', {
        context: 'widget-onboarding',
      })
    }
  }),
  withHandlers({
    handlePopUp: props => () => {
      props.setUpdating(true)
      const link = document.querySelector(".segment-enable-button a").href
      popUp({
        path: link,
        onClose: () => {
          props.setUpdating(false)
          props.setErrorNotification(true)
        },
        onMessage: () => {
          props.actions.updateOrgProperties({
            properties: { signUpDone: true,  segmentEnabled: true },
          })
          props.setUpdating(false)
          props.setSegmentEnabled(true)
          props.setSuccessNotification(true)
          props.setErrorNotification(false)
          props.setShowNextButton(true)
        }
      })
    },
    onContinueClick: props => () => {
      props.actions.updateOrgProperties({ properties: { signUpDone: true }, redirect: true })
    },
  })
)(InstallSegment)


// WEBPACK FOOTER //
// ./src/layouts/InstallSegment/index.js